import React from 'react';
import { SEOBlock } from '../../../common/components';
import { MainScreen } from '../main-screen';
import { Advantages } from '../advantages';
import { PopularCategories } from '../popular-categories';
import { Catalogue } from '../catalogue';
import { MainInfoTexts } from './main-info-texts';

export const CatalogueLayout = () => (
	<div className="services-landings__content">
		<MainScreen {...MainInfoTexts.catalogue} />
		<Advantages />
		<PopularCategories />
		<Catalogue />
		<SEOBlock />
	</div>
);
